var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Portal',{attrs:{"to":"app-dialog"}},_vm._l((_vm.activeComponents),function(activeComponent){return _c(activeComponent.component,_vm._g(_vm._b({key:typeof activeComponent.component === 'string'
          ? activeComponent.component
          : activeComponent.component._uid,tag:"component"},'component',activeComponent.props,false),activeComponent.events))}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }